export default {
	methods: 
    {		
		nuevoModal()
		{
		  this.resetDataIndex()
		  this.updateGlobal({state: 'openModal/modal/value',    data: true });
		  this.updateGlobal({state: 'openModal/modal/title',    data: 'Nuevo Asesor'});
		  this.updateGlobal({state: 'openModal/modal/modal',    data: 'Nuevo'});
		},		
		async getFiltrar()
		{
			await this.getDataGet({ route: 'get_listasesores', data: 'usuarios'})
			// frontend await this.searchGetIdb({tabla:'servicios_nuevos',campo:'iniciolabores',value:'',principal:'info_afiliacion'})
		}		
	},
}